import { render } from "./ConfirmationContent.vue?vue&type=template&id=a87e6e6e&scoped=true"
import script from "./ConfirmationContent.vue?vue&type=script&lang=js"
export * from "./ConfirmationContent.vue?vue&type=script&lang=js"

import "./ConfirmationContent.vue?vue&type=style&index=0&id=a87e6e6e&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-a87e6e6e"

export default script